<template>
  <vs-popup :title="$t('Users')" :active.sync="popupActive">
    <div>
      <div class="vx-row">
        <div class="vx-col w-full mb-base">
          <data-grid
            ref="grid"
            stripe
            :data-source="gridDataSource"
            :columns="[
              { title: $t('model') },
              { title: $t('plate') },
              { title: $t('typeOfTransport') },
              { title: $t('Action') },
            ]"
          >
            <template slot-scope="{ row }">
              <td style="width: 25%">{{ row.model }}</td>
              <td style="width: 30%">{{ row.plate }}</td>
              <td style="width: 20%">
                {{ row.transportDiscriminator === "Truck" ? "وانت" : "موتورسیکلت" }}
              </td>
              <td style="width: 25%">
                <vs-button
                  radius
                  color="success"
                  size="small"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-plus"
                  @click.prevent="selectTransport(row)"
                  class="ml-4 d-inline"
                ></vs-button>
              </td>
            </template>
          </data-grid>
        </div>
      </div>
    </div>
  </vs-popup>
</template>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss"
import DataGrid from "@/components/datagrid/DataGrid"
export default {
  name: "",
  props: {
    showUserList: { default: false },
    roleCurrent: {},
  },
  data() {
    return {
      gridDataSource: { data: [] },
      fullTransport: {},
    }
  },
  computed: {
    popupActive: {
      get: function() {
        return this.showUserList
      },
      set: function() {
        this.$emit("finish")
      },
    },
  },
  watch: {
    showUserList() {
      this.gridDataSource = { type: "app", service: "Shipping/api/TransportsQuery" }
      setTimeout(() => {
        this.$refs.grid.renderGrid()
      }, 0)
    },
  },

  components: {
    DataGrid,
  },
  methods: {
    selectTransport(Transport) {
      this.fullTransport = Transport
      this.$emit("onSelectTransport", this.fullTransport)
      this.$emit("finish")
    },
  },
}
</script>
